module.exports = __webpack_public_path__ + "sweat.8071cf9c.png";